import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCivilUnionCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Unione Civile',
    path: '/mutazioni/persona/unione-civile',
  },
];

export const RegistrationCivilUnionCrumbs = [
  ...SearchPersonCivilUnionCrumbs,
  {
    name: 'Registrazione Unione civile',
    path: '/mutazioni/persona/unione-civile/registrazione',
  },
];
